import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=06ae72d9&scoped=true&"
import script from "./products.page.vue?vue&type=script&lang=js&"
export * from "./products.page.vue?vue&type=script&lang=js&"
import style0 from "./products.page.vue?vue&type=style&index=0&id=06ae72d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae72d9",
  null
  
)

export default component.exports